import script from "./TressSearchPageWrapper.vue?vue&type=script&setup=true&lang=ts"
export * from "./TressSearchPageWrapper.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__